import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { pageFooterDataEn } from './pageFooterData.en';
import { pageFooterDataEs } from './pageFooterData.es';
import { pageFooterDataPt } from './pageFooterData.pt';
import type { PageFooterData } from './types/PageFooterData';

export const pageFooterDataByLocale: Record<I18nLocale, PageFooterData> = {
  en: pageFooterDataEn,
  es: pageFooterDataEs,
  pt: pageFooterDataPt,
};
